__turbopack_context__.v({
  "back": "FlowHeader-module-scss-module__53FH2G__back",
  "close": "FlowHeader-module-scss-module__53FH2G__close",
  "header": "FlowHeader-module-scss-module__53FH2G__header",
  "indicator": "FlowHeader-module-scss-module__53FH2G__indicator",
  "indicator-group": "FlowHeader-module-scss-module__53FH2G__indicator-group",
  "logo": "FlowHeader-module-scss-module__53FH2G__logo",
});
